import { RouteComponent } from '@townsquare/router/RouteComponent';
import React from 'react';

import { SiteBannerProvider } from '@townsquare/site-banner';

export function EmbedRoute() {
	return (
		<SiteBannerProvider>
			<RouteComponent />
		</SiteBannerProvider>
	);
}
